export default __webpack_public_path__ + "static/media/Blocked.24474cc1.svg";